import { render } from "./AccountIPs.vue?vue&type=template&id=441544f2&scoped=true"
import script from "./AccountIPs.vue?vue&type=script&lang=js"
export * from "./AccountIPs.vue?vue&type=script&lang=js"

import "./AccountIPs.vue?vue&type=style&index=0&id=441544f2&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441544f2"]])

export default __exports__